/**
 * City landmark images for /chevy-sales-* pages.
 *
 * All images are self-hosted under /public/images/cities/ to guarantee
 * rendering (Wikimedia Special:FilePath URLs are rate-limited and can
 * fail under hot-link / CSP). Original Wikimedia sources are recorded in
 * `sourceUrl` for license verification and attribution.
 *
 * Per-city object shape (per spec):
 *   {
 *     src:          self-hosted public path
 *     alt:          accessibility text
 *     credit:       human-readable attribution
 *     sourceUrl:    URL of the source page where the file was retrieved
 *     license:      license note ("Verify on source page" until human-reviewed)
 *     replaceable:  true — these can be swapped for owner photos later
 *     isPlaceholder: true when no recognizable local landmark photo was
 *                    available and a regional photo is used instead
 *   }
 */
const W = "https://commons.wikimedia.org/wiki";

const make = (slug, alt, file, opts = {}) => ({
  src: `/images/cities/${slug}.jpg`,
  alt,
  credit: opts.credit || "Wikimedia Commons (self-hosted copy)",
  sourceUrl: file ? `${W}/File:${file}` : `${W}/Category:Ohio`,
  license: "Verify on source page",
  replaceable: true,
  isPlaceholder: !!opts.isPlaceholder,
});

export const CITY_IMAGES = {
  "central-ohio": make("central-ohio", "Downtown Columbus, Ohio skyline at dusk", "Columbus-ohio-skyline.jpg"),

  "grove-city-oh":      make("grove-city",       "Central Ohio skyline near Grove City, OH (placeholder)", "Columbus-ohio-skyline.jpg", { isPlaceholder: true }),
  "columbus-oh":        make("columbus",         "Scioto Mile and downtown Columbus, Ohio",                  "Columbus_Scioto_Mile_02.jpg"),
  "hilliard-oh":        make("hilliard",         "Union County Courthouse, near Hilliard, OH (placeholder)", "Union_County_Courthouse_Marysville.jpg", { isPlaceholder: true }),
  "dublin-oh":          make("dublin",           "The Dublin Link pedestrian bridge in Dublin, OH",          "Dublin_Link_02.jpg"),
  "gahanna-oh":         make("gahanna",          "Historic depot near Gahanna, OH (placeholder)",            "Pickerington_Depot.jpg", { isPlaceholder: true }),
  "westerville-oh":     make("westerville",      "Holmes Hotel area in Westerville, OH",                     "Holmes_Hotel_%E2%80%94_Westerville,_Ohio_-_49358723636.jpg"),
  "reynoldsburg-oh":    make("reynoldsburg",     "Blacklick Creek at Blacklick Woods Metro Park near Reynoldsburg, OH", "Blacklick_Woods-Blacklick_Creek_3.jpg"),
  "pickerington-oh":    make("pickerington",     "Historic Pickerington Depot in Pickerington, OH",          "Pickerington_Depot.jpg"),
  "groveport-oh":       make("groveport",        "Groveport Town Hall in Groveport, OH",                     "Groveport_Town_Hall_%E2%80%94_Groveport,_Ohio.jpg"),
  "canal-winchester-oh":make("canal-winchester", "North High Street Historic District in Canal Winchester, OH", "North_High_Street_Historic_District_in_Canal_Winchester.jpg"),
  "ashville-oh":        make("ashville",         "Historic Ashville, OH streetscape",                        "AshvilleOH18.JPG"),
  "circleville-oh":     make("circleville",      "Pickaway County Courthouse in Circleville, OH",            "Pickaway_County_Courthouse.JPG"),
  "london-oh":          make("london",           "Madison County Courthouse in London, OH",                  "London-ohio-courthouse.jpg"),
  "plain-city-oh":      make("plain-city",       "Clock tower in Plain City, OH",                            "Clock_tower_-_Plain_City,_Ohio.jpg"),
  "delaware-oh":        make("delaware",         "Small-town downtown scene near Delaware, OH (placeholder)","Holmes_Hotel_%E2%80%94_Westerville,_Ohio_-_49358723636.jpg", { isPlaceholder: true }),
  "marysville-oh":      make("marysville",       "Union County Courthouse in Marysville, OH",                "Union_County_Courthouse_Marysville.jpg"),
  "pataskala-oh":       make("pataskala",        "Aerial view of Pataskala, OH",                             "Pataskala,_Ohio_Aerial.JPG"),
  "lancaster-oh":       make("lancaster",        "East Main Street in downtown Lancaster, OH",               "Lancaster_Ohio_Main_Street.jpg"),
  "chillicothe-oh":     make("chillicothe",      "South Paint Street in downtown Chillicothe, OH",           "South_Paint_in_downtown_Chillicothe.jpg"),
  "newark-oh":          make("newark",           "Licking County Courthouse in Newark, OH",                  "Newark-ohio-courthouse.jpg"),
  "whitehall-oh":       make("whitehall",        "Central Ohio scene near Whitehall, OH (placeholder)",      "Columbus_Scioto_Mile_02.jpg", { isPlaceholder: true }),

  default: make("central-ohio", "Central Ohio skyline background", "Columbus-ohio-skyline.jpg", { isPlaceholder: true }),
};
